export default function(a, b) {
  return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
}



//////////////////
// WEBPACK FOOTER
// ./packages/layout/node_modules/d3-shape/src/descending.js
// module id = 413
// module chunks = 0